<div class="bottom-sheet" (click)="$event.stopPropagation()">
    <div class="drag-indicator"></div>
    <div class="sheet-title text-center mt-3 mb-4">Pilih Mode Presensi</div>

    <div class="option-container d-flex justify-content-center px-3">
        <!-- Option: Umum -->
        <div class="option-item mx-3" (click)="selectMode(1)">
            <div class="option-card card-blue mb-2">
                <div class="icon-bg bg-blue-dark">
                    <nb-icon icon="briefcase-outline"></nb-icon>
                </div>
            </div>
            <div class="option-label text-center">Umum</div>
        </div>

        <!-- Option: Luar Kantor -->
        <div *ngIf="isLuarKantorAllowed" class="option-item mx-3" [ngClass]="{'disabled': !isLuarKantorAllowed}"
            (click)="selectMode(2)">
            <div class="option-card card-green mb-2">
                <div class="icon-bg bg-green-dark">
                    <nb-icon icon="globe-2-outline"></nb-icon>
                </div>
            </div>
            <div class="option-label text-center">Tugas Luar Kantor</div>
        </div>

        <!-- Option: WFH -->
        <div class="option-item mx-3" [ngClass]="{'disabled': !isWfhAllowed}" (click)="selectMode(3)">
            <div class="option-card card-orange mb-2">
                <div class="icon-bg bg-orange-dark">
                    <nb-icon icon="home-outline"></nb-icon>
                </div>
            </div>
            <div class="option-label text-center">WFH</div>
        </div>
    </div>
</div>